import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=39ddb460&scoped=true"
import script from "./EditPage.vue?vue&type=script&lang=js"
export * from "./EditPage.vue?vue&type=script&lang=js"
import style0 from "./EditPage.vue?vue&type=style&index=0&id=39ddb460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ddb460",
  null
  
)

export default component.exports